export default __webpack_public_path__ + "static/media/zbir-2.7d91be40.jpg";